
import { TextAlignProperty } from "csstype";
import {
  computed,
  CSSProperties,
  defineComponent,
  PropType,
  ref,
  toRefs,
  watch,
} from "vue";
import BaseLabel from "../base-label/base-label.vue";
import BaseTypography from "../base-typography/base-typography.vue";
import BaseFormInlineEntryDescription from "./components/base-form-inline-entry-description.vue";
export default defineComponent({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: "",
    },
    staticLabel: {
      type: String,
      default: "",
    },
    formEntryValue: {
      type: [String, Number, Boolean] as PropType<
        string | number | boolean | null
      >,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    textAlign: {
      type: String as PropType<TextAlignProperty>,
      default: "left",
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    baseStyle(): CSSProperties {
      return {
        textAlign: this.textAlign,
      };
    },
  },
  components: { BaseLabel, BaseFormInlineEntryDescription, BaseTypography },
  setup(props) {
    const { formEntryValue } = toRefs(props);
    const keepLabelRaised = ref(false);

    const keepLabelRaisedComputed = computed((): boolean => {
      return (
        keepLabelRaised.value ||
        Boolean(props.formEntryValue) ||
        props.formEntryValue === 0
      );
    });

    const labelClasses = computed((): object => ({
      "label-lowered": !props.staticLabel,
      "label-static": Boolean(props.staticLabel),
      "label-raised": keepLabelRaisedComputed.value,
      "ava-truncate": true,
    }));

    const noLabel = computed((): boolean => {
      return !(Boolean(props.staticLabel) || Boolean(props.label));
    });
    const noLabelClass = computed((): string =>
      noLabel.value ? "no-label-class" : ""
    );

    watch(formEntryValue, (newValue) => {
      keepLabelRaised.value = Boolean(newValue);
    });

    return {
      keepLabelRaised,
      keepLabelRaisedComputed,
      labelClasses,
      noLabel,
      noLabelClass,
    };
  },
});
